module.exports = "/legacy/9f602266f7d55f5e1ef5e22ff7192678.svg";